import { render, staticRenderFns } from "./languageSwitcher.vue?vue&type=template&id=2cdde67c&"
import script from "./languageSwitcher.vue?vue&type=script&lang=js&"
export * from "./languageSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports